import { FC } from 'react';
import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, HexColor } from '@gn-audio/jss-components';

import Banner from 'common/components/Banner';

export type TextBannerProps = ComponentProps & {
  fields: {
    Title: Field<string>;
    Body: Field<string>;
    BackgroundColor: Field<string>;
    BottomOverlapHeight: Field<string>;
  };
};

const TextBanner: FC<TextBannerProps> = ({ fields }) => {
  return (
    <Banner
      bottomOverlapHeight={fields.BottomOverlapHeight?.value}
      title={fields.Title?.value}
      backgroundColor={fields.BackgroundColor?.value as HexColor}
      body={fields.Body?.value}
    />
  );
};

export default withDatasourceCheck()<TextBannerProps>(TextBanner);
